import React from 'react';
import style from './style.module.css';

const Title = ({ children }) => <div className={style.title}>{children}</div>;

export default Title;
